export const buildInfo = {
  branch: 'main',
  commit: 'e28a008',
  buildDate: '2026-11-05T13:47:43.290Z',
};
